import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RxjsComponent } from '@smooved/core';
import { Text } from '../../interfaces/meta/questions/text';

@Component({
    selector: 'smvd-shared-question-text',
    templateUrl: 'question-text.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionTextComponent extends RxjsComponent {
    @Input() public question: Text;
    @Input() public group: UntypedFormGroup;
}
